import { auth } from "./auth";

// This app's sign-in and sign-out, with its sf_env already bound (see auth.tsx).
export const { startSignIn, signInAgain, startSignOut, isRedirecting } = auth;
